export const helpGivenArray = ["Medical", "Education", "Agriculture", "Sukanya", "Stitching Machine", "Mixer", "Others"]